import {
  ChangeDetectionStrategy,
  Component,
  output,
  signal,
} from '@angular/core';
import {
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CancelReasonDialogResult } from '../cancel-job.types';

@Component({
  selector: 'app-cancel-job-reason-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: './cancel-job-reason-dialog.component.html',
  styleUrl: './cancel-job-reason-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelJobReasonDialogComponent {
  readonly maxLength = 1000;
  readonly confirmed = output<CancelReasonDialogResult>();
  readonly closed = output<void>();
  readonly submitting = signal(false);

  readonly reasonControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(this.maxLength)],
  });

  remainingCharacters(): number {
    return this.maxLength - this.reasonControl.value.length;
  }

  get hasRequiredError(): boolean {
    return this.reasonControl.touched && this.reasonControl.hasError('required');
  }

  onConfirm(): void {
    if (this.submitting()) {
      return;
    }

    this.reasonControl.markAsTouched();
    if (this.reasonControl.invalid) {
      return;
    }

    this.submitting.set(true);
    this.confirmed.emit({
      confirmed: true,
      reason: this.reasonControl.value.trim(),
    });
  }

  onClose(): void {
    if (this.submitting()) {
      return;
    }
    this.closed.emit();
  }
}
